import { Component } from "react";

import AppRouteFallback from "./AppRouteFallback";

/** Prevents a module render exception from leaving the authenticated workspace blank. */
export default class ModuleErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Keep technical details in the browser console without exposing them in the UI.
    console.error("Module render failed", error, errorInfo);
  }

  componentDidUpdate(previousProps) {
    if (
      this.state.hasError
      && previousProps.resetKey !== this.props.resetKey
    ) {
      this.setState({ hasError: false });
    }
  }

  handleRetry = () => {
    this.setState({ hasError: false });
  };

  render() {
    if (this.state.hasError) {
      return <AppRouteFallback mode="moduleError" onRetry={this.handleRetry} />;
    }

    return this.props.children;
  }
}
